import { useSyncExternalStore } from "react";

const queries = new Map<string, MediaQueryList>();
const mql = (q: string) => { let m = queries.get(q); if (!m) { m = window.matchMedia(q); queries.set(q, m); } return m; };

/** True while the media query matches; re-renders when it changes (rotate the phone, resize the window). */
export function useMedia(query: string): boolean {
  return useSyncExternalStore((cb) => { const m = mql(query); m.addEventListener("change", cb); return () => m.removeEventListener("change", cb); }, () => mql(query).matches, () => false);
}
/** A phone-sized screen: the app lays itself out like an app, with the tools along the bottom. */
export const usePhone = (): boolean => useMedia("(max-width: 720px)");
